<div class="sg-cell-inner">
    <div class="text-bold">{{name}}</div>
    <div>({{numOfProducts}} Products)</div>
</div>